import React from 'react';
import { Form, Card } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
const ViewChecklistAnswersModal = _ref => {
  let {
    show,
    onHide,
    checklistAnswers
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!checklistAnswers || checklistAnswers.length === 0) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    show: show,
    title: t('checklist_answers'),
    onHide: onHide,
    renderBody: () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
      className: "mb-3"
    }, t('completed_checklist_review')), /*#__PURE__*/React.createElement("p", {
      className: "text-muted mb-4"
    }, t('view_submitted_answers_and_comments')), /*#__PURE__*/React.createElement("div", {
      style: {
        maxHeight: '60vh',
        overflowY: 'auto'
      },
      className: "mb-4"
    }, checklistAnswers.map((answer, index) => {
      const selectedIsOption1 = answer.selected_option === 'option_1';
      const selectedIsOption2 = answer.selected_option === 'option_2';
      return /*#__PURE__*/React.createElement(Card, {
        key: answer.id,
        className: "mb-3 p-3 border"
      }, /*#__PURE__*/React.createElement("h6", {
        className: "mb-3"
      }, /*#__PURE__*/React.createElement("strong", null, index + 1, ". ", answer.question)), /*#__PURE__*/React.createElement(Form.Group, {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "p-2 mb-2 rounded ".concat(!selectedIsOption1 ? 'bg-light' : 'border border-success'),
        style: {
          opacity: !selectedIsOption1 ? 0.5 : 1
        }
      }, /*#__PURE__*/React.createElement(Form.Check, {
        type: "radio",
        label: answer.option_1,
        checked: selectedIsOption1,
        disabled: true,
        readOnly: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "p-2 rounded ".concat(!selectedIsOption2 ? 'bg-light' : 'border border-success'),
        style: {
          opacity: !selectedIsOption2 ? 0.5 : 1
        }
      }, /*#__PURE__*/React.createElement(Form.Check, {
        type: "radio",
        label: answer.option_2,
        checked: selectedIsOption2,
        disabled: true,
        readOnly: true
      }))), answer.comments && answer.comments.trim() && /*#__PURE__*/React.createElement("div", {
        className: "mt-3 p-3 bg-info bg-opacity-10 rounded border border-info"
      }, /*#__PURE__*/React.createElement("strong", {
        className: "text-info"
      }, t('comments'), ":"), /*#__PURE__*/React.createElement("p", {
        className: "mb-0 mt-2"
      }, answer.comments)));
    })))
  });
};
export default ViewChecklistAnswersModal;